import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PdvService } from '../../services/pdv/pdv.service';
import { OrdersService } from '../../services/order/orders.service';
import { MenuService } from '@app/services/menu/menu.service';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';

@Component({
    selector: 'best-offers',
    templateUrl: 'best-offers.component.html',
    styleUrls: ['best-offers.component.scss']
})

export class BestOffersComponent {
    bestSalesOffers: any[] = [];
    loadBestOffers: boolean;
    close = false;
    idPdv: string;
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    orderType: number;
    subscriptions: Subscription[] = [];
    subscriptions2: Subscription[] = [];
    orderTypes: any[];
    menuTime: number;
    offerNbr: number;
    nbrOffersAuthorizedSite: number;
    orderProg;
    constructor(
        private pdvService: PdvService,
        private menuService: MenuService,
        private ordersService: OrdersService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router
    ) {

    }
    ngOnInit() {
        this.idPdv = this.pdvService.idPdv;
        const subs8 = this.ordersService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs9 = this.ordersService.orderType.subscribe((orderType) => {
            this.orderType= orderType;
        });
        const subs2 = this.ordersService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getBestOffers();
        });
        const subs6 = this.ordersService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        const subs7 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        this.subscriptions2.push(subs2, subs6, subs7, subs8,subs9);
    }

    getBestOffers() {
        this.loadBestOffers = true;
        this.menuService.getOffers(this.orderType, this.orderProg).subscribe(
            (offers: any[]) => {
                this.loadBestOffers = false;
                this.bestSalesOffers = offers;
            }
        )
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
    OpenMenuModal(i) {
        if (this.chosenOrderType > 0) {
            if (this.bestSalesOffers[i].offer == null || (this.bestSalesOffers[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3 menu-modal' });
                this.bsModalRef.content.menu = this.bestSalesOffers[i];
            } else {
                this.toastr.error('', 'You have reached the number of authorized offers');
            }
        } else {
            this.setOrderType();
        }
    }
    setOrderType() {
        this.route.params.subscribe(params => {
            if (params['menu']) {
                this.router.navigate(["/modes"], { queryParams: { menu: params['menu'] } });
            }
            if (params['family']) {
                let querparams = { famille: params['family'] }
                this.router.navigate(["/modes"], { queryParams: querparams });
            }
            if (!params['menu'] && !params['family']) {
                this.router.navigate(["/modes"]);
            }
        })
    }
}
